import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useToast} from 'react-native-toast-notifications';
import {useModal} from 'extensions/viewport/useModal';
import {Prompt} from 'interface/base/Prompt';
import {describe} from 'utils/mediafire';

export function useModalDescribe(id: string, name: string, description: string, isFolder: boolean) {
  const {t} = useLingui();
  const modal = useModal();
  const toast = useToast();

  const open = useCallback(() => {
    modal.open(
      <Prompt
        title={t`Describe ${isFolder ? 'Folder' : 'File'}`}
        text={t`Give “${name}” a description`}
        options={{
          type: 'plain-text',
          placeholder: t`Set a description`,
          defaultValue: description,
          selectInput: 'all',
        }}
        buttons={[
          {
            mode: 'primary',
            text: t`Ok`.toUpperCase(),
            onPress: async (value: string) => {
              if (!value) return modal.exit();
              const res = await describe(id, value);
              if (res && res['result'] === 'Success') {
                toast.show(t`Updated the description for “${name}”`);
              } else {
                toast.show(res?.message ?? t`Failed to update description`, {type: 'danger'});
              }
              modal.exit();
            },
          },
          {
            mode: 'cancel',
            text: t`Cancel`.toUpperCase(),
            onPress: modal.exit,
          },
        ]}
      />
    );
  }, [id, name, description]);

  return {open, exit: modal.exit};
}
